export const TALK_TO_SALES_LINK = 'https://syncly.app/talk-to-sales';
export const talkToSales = () => window.open(TALK_TO_SALES_LINK, '_blank');
